
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationTrunk from "../../decorations/jungle/DecorationTrunk";
import TrapMarkerSpikes from "../../editor/trap-markers/jungle/TrapMarkerSpikes";
import PlatformMarkerFoliage3 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage3";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformFoliage2 from "../../platforms/jungle/PlatformFoliage2";
import PlatformFoliage1 from "../../platforms/jungle/PlatformFoliage1";
import PlatformMarkerFoliage4 from "../../editor/platform-markers/jungle/PlatformMarkerFoliage4";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import PositionMarker from "../../editor/PositionMarker";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import MoverData from "../../../components/platformer/MoverData";
import CheckpointMarker from "../../editor/CheckpointMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class JungleChunkEasy4 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 341, y ?? 108);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 4941, 661);
    this.add(editor_bounds_right);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, -331, 661);
    this.add(editor_bounds_left);

    // trunk_png_1
    const trunk_png_1 = new DecorationTrunk(scene, 1354, 676);
    this.add(trunk_png_1);

    // trunk_png_2
    const trunk_png_2 = new DecorationTrunk(scene, -72, 806);
    this.add(trunk_png_2);

    // trunk_png
    const trunk_png = new DecorationTrunk(scene, 508, 702);
    this.add(trunk_png);

    // trunk_png_3
    const trunk_png_3 = new DecorationTrunk(scene, 3847, 837);
    this.add(trunk_png_3);

    // trapSpikesMarker
    const trapSpikesMarker = new TrapMarkerSpikes(scene, -80, 412);
    this.add(trapSpikesMarker);

    // platformMarkerFoliage_1
    const platformMarkerFoliage_1 = new PlatformMarkerFoliage3(scene, 1351, 370);
    this.add(platformMarkerFoliage_1);

    // platformMarkerFoliage_2
    const platformMarkerFoliage_2 = new PlatformMarkerFoliage3(scene, 2092, 567);
    this.add(platformMarkerFoliage_2);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 3885, 9);
    this.add(megaGemMarker_2);

    // platformFoliage2
    const platformFoliage2 = new PlatformFoliage2(scene, 1700, 411);
    this.add(platformFoliage2);

    // trunk_png_4
    const trunk_png_4 = new DecorationTrunk(scene, 946, 745);
    this.add(trunk_png_4);

    // trunk_png_5
    const trunk_png_5 = new DecorationTrunk(scene, 2080, 871);
    this.add(trunk_png_5);

    // platformFoliage_2
    const platformFoliage_2 = new PlatformFoliage1(scene, 2540, 440);
    this.add(platformFoliage_2);

    // trunk_png_6
    const trunk_png_6 = new DecorationTrunk(scene, 1692, 724);
    this.add(trunk_png_6);

    // trunk_png_7
    const trunk_png_7 = new DecorationTrunk(scene, 3114, 824);
    this.add(trunk_png_7);

    // platformFoliage_4
    const platformFoliage_4 = new PlatformFoliage1(scene, 954, 440);
    this.add(platformFoliage_4);

    // platformMarkerFoliage_3
    const platformMarkerFoliage_3 = new PlatformMarkerFoliage4(scene, 3130, 510);
    this.add(platformMarkerFoliage_3);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 2084, 483);
    this.add(gemMarker_1);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 1759, 327);
    this.add(gemMarker_2);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 959, 356);
    this.add(gemMarker_3);

    // gemMarker_4
    const gemMarker_4 = new SmallGemMarker(scene, 457, 311);
    this.add(gemMarker_4);

    // gemMarker_5
    const gemMarker_5 = new SmallGemMarker(scene, 2548, 354);
    this.add(gemMarker_5);

    // platformMarkerFoliage_4
    const platformMarkerFoliage_4 = new PlatformMarkerFoliage4(scene, 3868, 526);
    this.add(platformMarkerFoliage_4);

    // trapSpikesMarker_1
    const trapSpikesMarker_1 = new TrapMarkerSpikes(scene, 3853, 444);
    this.add(trapSpikesMarker_1);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 4017, 433);
    this.add(megaGemMarker);

    // platformMarkerFoliage_5
    const platformMarkerFoliage_5 = new PlatformMarkerFoliage3(scene, 4515, 373);
    this.add(platformMarkerFoliage_5);

    // trunk_png_8
    const trunk_png_8 = new DecorationTrunk(scene, 4503, 677);
    this.add(trunk_png_8);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 4507, 271);
    this.add(gemMarker_7);

    // platformMarkerFoliage_6
    const platformMarkerFoliage_6 = new PlatformMarkerFoliage4(scene, -55, 492);
    this.add(platformMarkerFoliage_6);

    // platformMarkerFoliage
    const platformMarkerFoliage = new PlatformMarkerFoliage3(scene, 523, 399);
    this.add(platformMarkerFoliage);

    // trapSpikesMarker_3
    const trapSpikesMarker_3 = new TrapMarkerSpikes(scene, 1256, 320);
    this.add(trapSpikesMarker_3);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 2176, 79);
    this.add(gemMarker);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 2122, 255);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 2157, 132);
    this.add(positionMarker_1);

    // platformMarkerJungleLog
    const platformMarkerJungleLog = new PlatformMarkerJungleLog(scene, 2127, 255);
    this.add(platformMarkerJungleLog);

    // gemMarker_9
    const gemMarker_9 = new SmallGemMarker(scene, 2219, 17);
    this.add(gemMarker_9);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 3306, -107);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 3474, -109);
    this.add(gemMarker_14);

    // positionMarker_4
    const positionMarker_4 = new PositionMarker(scene, 3241, -39);
    this.add(positionMarker_4);

    // positionMarker_5
    const positionMarker_5 = new PositionMarker(scene, 3564, -49);
    this.add(positionMarker_5);

    // platformMarkerJungleLog_2
    const platformMarkerJungleLog_2 = new PlatformMarkerJungleLog(scene, 3246, -39);
    this.add(platformMarkerJungleLog_2);

    // gemMarker_15
    const gemMarker_15 = new SmallGemMarker(scene, 3388, -108);
    this.add(gemMarker_15);

    // trunk_png_9
    const trunk_png_9 = new DecorationTrunk(scene, 2543, 743);
    this.add(trunk_png_9);

    // trapSpikesMarker_6
    const trapSpikesMarker_6 = new TrapMarkerSpikes(scene, 2923, 443);
    this.add(trapSpikesMarker_6);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 3115, 417);
    this.add(megaGemMarker_1);

    // platformFoliage
    const platformFoliage = new PlatformFoliage2(scene, 3830, 80);
    this.add(platformFoliage);

    // gemMarker_16
    const gemMarker_16 = new SmallGemMarker(scene, 3708, 407);
    this.add(gemMarker_16);

    // trapSpikesMarker_8
    const trapSpikesMarker_8 = new TrapMarkerSpikes(scene, 3765, 31);
    this.add(trapSpikesMarker_8);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 1397, 294);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 74, 368);
    this.add(gemMarker_11);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 35, 427);
    this.add(checkpointMarker);

    // checkpointMarker_1
    const checkpointMarker_1 = new CheckpointMarker(scene, 2000, 517);
    this.add(checkpointMarker_1);

    // platformMarkerFoliage_7
    const platformMarkerFoliage_7 = new PlatformMarkerFoliage3(scene, 2700, 35);
    this.add(platformMarkerFoliage_7);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 2608, -90);
    this.add(gemMarker_6);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 2769, -90);
    this.add(gemMarker_8);

    // this (components)
    new ChunkBoundaries(this);

    // platformMarkerJungleLog (components)
    const platformMarkerJungleLogMoverData = new MoverData(platformMarkerJungleLog);
    platformMarkerJungleLogMoverData.startMarker = positionMarker;
    platformMarkerJungleLogMoverData.endMarker = positionMarker_1;
    platformMarkerJungleLogMoverData.startWait = 500;

    // platformMarkerJungleLog_2 (components)
    const platformMarkerJungleLog_2MoverData = new MoverData(platformMarkerJungleLog_2);
    platformMarkerJungleLog_2MoverData.startMarker = positionMarker_4;
    platformMarkerJungleLog_2MoverData.endMarker = positionMarker_5;
    platformMarkerJungleLog_2MoverData.startWait = 500;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
